let VNotification = {
  data: () => ({
    message: '',
    value: false
  }),

  render (h) {
    return h('v-snackbar', {
      ref: 'snackbar',
      on: { input: ev => this.value = ev },
      props: this.$data
    }, [
      this.message,
      h('v-btn', {
        on: { click: ev => this.value = false },
        props: { flat: true }
      }, [ 'Close' ])
    ])
  }
}

export default {
  install: function (Vue, opt) {
    let VNotificationConstructor = Vue.extend(VNotification)

    Vue.prototype.$notify = function (options) {
      let container = document.getElementById('v-app-plugin-container')
      let instance = new VNotificationConstructor({
        data: options
      })
      instance.$mount()
      container.appendChild(instance.$el)
      instance.value = true
    }
  }
}
